import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadStaticPageContent } from 'redux/StaticPages/actions';
import { ssrHandler } from 'utils';
import { applyPageStats } from 'utils/pageStats';

import SupportTemplate from './SupportTemplate';

class Support extends PureComponent {
  render() {
    if (!this.props.page || !this.props.page.data) {
      return null;
    }

    return (
      <SupportTemplate name={this.props.name} page={this.props.page.data} />
    );
  }
}

Support.propTypes = {
  name: PropTypes.string,
  page: PropTypes.shape({
    data: PropTypes.object,
    isFetching: PropTypes.bool.isRequired
  })
};

function parsePathname(pathname) {
  const [name] = pathname.split('/').filter(Boolean).slice(-1);

  return name;
}

function mapStateToProps(state, props) {
  const name = parsePathname(props.location.pathname);

  const statsName = name.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

  const page = state.staticPages.items.find((page) => page.name === name);
  const stats = state.app.pageStats[statsName];

  return {
    name,
    page: applyPageStats(page, stats)
  };
}

function loadSupportData(store, nextState, replace, callback) {
  const { staticPages } = store.getState();

  const name = parsePathname(nextState.location.pathname);
  const page = staticPages.items.find((item) => item.name === name);

  // if (typeof page !== 'undefined') {
  //   return callback();
  // }

  const actions = [loadStaticPageContent(name)];

  ssrHandler(store.dispatch, actions, callback);
}

const createRoute = (store, pathname) => ({
  path: `/support/${pathname}/`,
  component: connect(mapStateToProps)(Support),
  onEnter: loadSupportData.bind(null, store)
});

const support = [
  'investor-relations',
  'capital-transactions',
  'representative-for-bond-owners'
];

export default (store) => support.map(createRoute.bind(null, store));



// WEBPACK FOOTER //
// ./src/components/Support/index.js